export default {
  namespaced: true,
  state: {},
  getters: {
    isExercito() {
      return location.hostname.includes('exercito');
    },
    isEmbedded() {
      return location.pathname.includes('/int/');
    },
    isBrokers() {
      return location.hostname.includes('brks');
    },
    isSubdomainTemSaude() {
      return location.hostname.includes('temsaude');
    },
    isTemSaude() {
      return location.hostname.includes('telemedicina.temsaude');
    },
    isPHS() {
      return location.hostname.includes('habitossaudaveis.temsaude');
    },
    isNamu() {
      return location.hostname.includes('namu');
    },
    isSaudeMental() {
      return location.hostname.includes('saudemental.temsaude');
    },
    isVcPode() {
      return location.hostname.includes('lif');
    },
    isCorpoMente() {
      return location.hostname.includes('corpoemente.temsaude');
    },
    isNovaSaude() {
      return location.hostname.includes('novasaude');
    },
    isKliniSaude() {
      return location.hostname.includes('telemedicina.klinisaude') || location.hostname.includes('klinitelemedicina');
    },
    partnerCheckActive(state, getters) {
      return (
        getters.isNovaSaude ||
        getters.isTemSaude ||
        getters.isCorpoMente ||
        getters.isPHS ||
        getters.isSaudeMental
      );
    },
    hasQueue(state, getters) {
      return !getters.isPHS && !getters.isExercito && !getters.isSaudeMental && !getters.isCorpoMente && !getters.isVcPode
    },
    hasSchedule(state, getters) {
      return !getters.isBrokers
    },
  },
  mutations: {},
  actions: {},
};
